import React from "react";
// components
import MainPageLayouts, { TMainPageLayouts } from "@/components/MainPageLayouts";
// enums
import ELayoutType from "@/cms/enums/ELayoutType";
// types
import TClientMainPageItemList from "@/cms/types/TClientMainPageItemList";
// types
import { TMainPageLayoutV2 } from "../type";


const MNPGV2ParentId = ( props:{templates:TClientMainPageItemList[], mapLayoutName:string, parentId:string, allowedComponent?:TMainPageLayouts[], params?:any, Wrapper?:any, _layoutType:ELayoutType} ) => {
    const components = props.templates.filter((item) => item.parentId === props.parentId && item.mapLayoutName === props.mapLayoutName);

    if ( !components || !props.templates || !props.mapLayoutName || !props.parentId ) return null;

    return components.map((item) => {
        const layout = item.layouts.find((item) => item.layoutType === ELayoutType.MAIN_PAGE);
        const Layout = MainPageLayouts?.[layout?.layoutName as string];
        if ( layout && Layout && (props.allowedComponent === undefined||props.allowedComponent.includes(layout.layoutName as TMainPageLayouts)) ) {
            if ( props.Wrapper ) {
                return <props.Wrapper key={item.id}><Layout templates={props.templates} template={item} params={props.params} _layoutType={props._layoutType} /></props.Wrapper>
            }
            return <Layout key={item.id} templates={props.templates} template={item} params={props.params} _layoutType={props._layoutType} />
        }
        return null;
    });
}

const MNPGV2MainPage = ( props:{templates:TClientMainPageItemList[], mapLayoutName?:string, _layoutType:ELayoutType} ) => {
    const components = props.templates.filter((item) => item.mapLayoutName === props.mapLayoutName && item.parentId === null );

    if ( !components || !props.templates ) return null;

    return components.map((item) => {
        const layout = item.layouts.find((item) => item.layoutType === ELayoutType.MAIN_PAGE);
        const Layout = MainPageLayouts?.[layout?.layoutName as string];
        if ( Layout ) return <Layout key={item.id} templates={props.templates} template={item} _layoutType={props._layoutType} />
        return null;
    })
}

const MNPGV2 = ( props:TMainPageLayoutV2 ) => {
    const { templates, mapLayoutName, parentId, allowedComponent, params, Wrapper  } = props;
    if ( templates && mapLayoutName && parentId ) {
        return <MNPGV2ParentId templates={templates} mapLayoutName={mapLayoutName} parentId={parentId} allowedComponent={allowedComponent} params={params} Wrapper={Wrapper} _layoutType={ELayoutType.MAIN_PAGE} />
    }
    if ( templates && mapLayoutName ) {
        return <MNPGV2MainPage templates={templates} mapLayoutName={mapLayoutName} _layoutType={ELayoutType.MAIN_PAGE} />;
    }
    return null;
}

const Component = React.memo(MNPGV2, ( prevProps:TMainPageLayoutV2, nextProps:TMainPageLayoutV2 ) => {
    return true;
});

export default Component;
